import { render } from "./guide-welcome.vue?vue&type=template&id=7a873609"
import script from "./guide-welcome.js?vue&type=script&lang=js"
export * from "./guide-welcome.js?vue&type=script&lang=js"

import "./guide-welcome.vue?vue&type=style&index=0&id=7a873609&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__